import { InsuredUser } from 'app/components/insured-users';
import { Column } from 'app/design/primitives/box';
import { type Profile } from 'app/network/profile';
import { theme } from './shared';

export function ProfileInsurance({ isPlace, profile }: { isPlace: boolean; profile?: Profile }) {
  if (!profile?.insured || isPlace) return null;
  return (
    <Column>
      <InsuredUser
        otherUser={{ insured: true, profile: { firstName: profile.firstName } }}
        placement="profile"
        style={{
          paddingHorizontal: theme.spacing['spacing.general.x2'],
          paddingVertical: theme.spacing['spacing.general.x2'],
        }}
      />
    </Column>
  );
}
